import React from "react";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./pages/Home/Home";
import { Routes, Route } from "react-router-dom";
import Header from "./components/CommonComponents/Header/Headers";
import FooterMenu from "./components/CommonComponents/Footer/FooterMenu";
import Contact from "./pages/Contact/Contact";
import Copyright from "./components/CommonComponents/Copyright/Copyright";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <FooterMenu />
      <Copyright />
    </div>
  );
}

export default App;
